import { Pipe } from '@angular/core';
var PowerPipe = (function () {
    function PowerPipe() {
    }
    PowerPipe.prototype.transform = function (num, power) {
        if (power === void 0) { power = 2; }
        return !isNaN(num)
            ? Math.pow(num, power)
            : num;
    };
    PowerPipe.decorators = [
        { type: Pipe, args: [{ name: 'pow' },] },
    ];
    /** @nocollapse */
    PowerPipe.ctorParameters = function () { return []; };
    return PowerPipe;
}());
export { PowerPipe };
//# sourceMappingURL=pow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/pow.js
// module id = 264
// module chunks = 4